import { render, staticRenderFns } from "./section-results-info-tips.vue?vue&type=template&id=c30c7462&scoped=true&"
import script from "./section-results-info-tips.vue?vue&type=script&lang=js&"
export * from "./section-results-info-tips.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c30c7462",
  null
  ,true
)

export default component.exports